import React from 'react';

import './CartNotification.scss';

interface Props {
    syncFailure: boolean;
}

export default function CartNotificationFailure(props: Props) {
    const visibilityClass = () => {
        if (props.syncFailure === true) {
            return 'cart-notification--visible';
        }

        return '';
    };

    return (
        <div className={'cart-notification cart-notification--failure ' + visibilityClass()}>
            <div className="cart-notification__icon">
                <svg className="icon">
                    <use xlinkHref="#icon-close" />
                </svg>
            </div>
            <div className="cart-notification__text">Es gab einen Fehler beim Update des Warenkorbs</div>
        </div>
    );
}
